import { useMemo, useState } from "react";
import { liveBulletins } from "@/mocks/qxian";

const allCats = ["全部", ...Array.from(new Set(liveBulletins.map((b) => b.category)))];

function tagStyle(tag: string) {
  if (tag === "官方回应") return "bg-primary-100 text-primary-700";
  if (tag === "待证实") return "bg-accent-100 text-accent-900";
  return "bg-secondary-100 text-secondary-900";
}

export default function LiveFeed() {
  const [cat, setCat] = useState("全部");

  const list = useMemo(
    () => (cat === "全部" ? liveBulletins : liveBulletins.filter((b) => b.category === cat)),
    [cat]
  );

  return (
    <section id="live" className="w-full bg-background-100/70 scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <span className="live-dot w-2 h-2 rounded-full bg-primary-500 inline-block"></span>
              LIVE · 实时追加
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">
              实时快报
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              逐条跟进的最新动态，按发布顺序排列，随时刷新都有新变化。
            </p>
          </div>
          <a
            href="#top"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors self-start md:self-auto"
          >
            <i className="ri-refresh-line"></i>
            拉取最新
          </a>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {allCats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={
                "whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer " +
                (cat === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 border border-background-300 text-foreground-700 hover:border-primary-300")
              }
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-6 grid gap-3">
          {list.map((b) => (
            <article
              key={b.id}
              className="group flex flex-col md:flex-row md:items-center gap-3 rounded-xl bg-background-50 border border-background-200 p-4 md:p-5 transition-colors hover:border-primary-200"
            >
              <div className="shrink-0 flex items-center gap-3 md:w-28">
                <span className="font-heading text-sm font-bold text-primary-600 tabular-nums">{b.time}</span>
                <span className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600 whitespace-nowrap">
                  {b.category}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">{b.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{b.summary}</p>
              </div>
              <span
                className={
                  "shrink-0 self-start md:self-center whitespace-nowrap rounded-full px-3 py-1 text-xs " + tagStyle(b.tag || "")
                }
              >
                {b.tag}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}